const hasFloorProp = ({ node, adservers }, propName) => {
	const ads = node?.type === 'PlacementNode' ? [node.adserver] : adservers;
	return !!ads?.some((a) => a?.floorProps?.[propName]);
};

const hideIfNot = (fld) => (__, ___, data) => !data[fld].value;
const hideWhenNoEmpty = hideIfNot('retryOnEmptyReturn');

module.exports = {
	hasFloorProp,
	hideIfNot,
	hideWhenNoEmpty,
};
